export const SUPPORT_EMAIL = 'hello@verybusy.io';
